<script lang="ts" module>
  export type CanvasDrawParams = {
    ctx: CanvasRenderingContext2D;
    width: number;
    height: number;
    canvas: HTMLCanvasElement;
  };
</script>

<script lang="ts">
  import { isPresent } from '@yp/common/identity.ts';
  import { onMount } from 'svelte';

  export let draw: (params: CanvasDrawParams) => void;
  export let clazz: string | undefined = undefined;

  let container: HTMLElement;
  let canvas: HTMLCanvasElement;
  let ctx: CanvasRenderingContext2D | undefined;

  function doDraw() {
    const width = container.clientWidth;
    const height = container.clientHeight;
    if (isPresent(ctx)) {
      // console.log('Canvas', { width, height });
      canvas.width = width;
      canvas.height = height;
      draw({ ctx, width, height, canvas });
    }
  }

  onMount(() => {
    ctx = canvas.getContext('2d') ?? undefined;
    doDraw();

    const obs = new ResizeObserver(doDraw);
    obs.observe(container);
    return () => obs.unobserve(container);
  });
</script>

<div class={`flex flex-col items-center justify-center ${clazz ?? ''}`} bind:this={container}>
  <canvas bind:this={canvas} />
</div>
